<div *ngIf="beneficiarioPagina!=''" class="container">

  <!-- Bloco fixo com ID/CPF/Nome/etc -->
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-row">
      <span><strong>ID Funcional:</strong> {{ beneficiarioPagina.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiarioPagina.cpf }}</span>
      <span><strong>Nome:</strong> {{ beneficiarioPagina.nome }}</span>
      <span><strong>Órgão:</strong> {{ beneficiarioPagina.orgao?.sigla }}</span>
      <span><strong>Matrícula:</strong> {{ beneficiarioPagina.matricula }}</span>
      <span><strong>Nascimento:</strong> {{ beneficiarioPagina.dataNascimento | date: 'dd/MM/yyyy' }}</span>
      <span><strong>Data de ingresso no Estado:</strong> {{ beneficiarioPagina.dataingressoEstado | date: 'dd/MM/yyyy' }}</span>
      <span><strong>Ano do primeiro emprego:</strong> {{ beneficiarioPagina.anoPrimeiroEmprego }}</span>
      <span><strong>UF do emprego anterior:</strong> {{ beneficiarioPagina.ufEmpregoAnterior }}</span>
      <span><strong>Ano de chegada ao Brasil:</strong> {{ beneficiarioPagina.anoChegadaBrasil }}</span>
      <span><strong>Sexo:</strong> {{ beneficiarioPagina.sexo }}</span>
      <span><strong>Estado Civil:</strong> {{ beneficiarioPagina.estadoCivil }}</span>
      <span><strong>Grupo Sanguíneo:</strong> {{ beneficiarioPagina.grupoSanguineo }}</span>
      <span><strong>Nacionalidade:</strong> {{ beneficiarioPagina.nacionalidade }}</span>
      <span><strong>Naturalidade:</strong> {{ beneficiarioPagina.naturalidade }}</span>
      <span><strong>UF:</strong> {{ beneficiarioPagina.uf }}</span>
      <span><strong>Grau de Instrução:</strong> {{ beneficiarioPagina.grauInstrucao }}</span>
      <span><strong>Nome da Mãe:</strong> {{ beneficiarioPagina.nomeMae }}</span>
      <span><strong>Nome do Pai:</strong> {{ beneficiarioPagina.nomePai }}</span>
      <span><strong>Email:</strong> {{ beneficiarioPagina.email }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="1"></app-etapas-beneficio>

  <!-- Documentos -->
  <mat-card class="militar-info">
    <h2>Documentos</h2>
    <div class="info-row">
      <span><strong>Identidade:</strong> {{ beneficiarioPagina.identidade?.numero }} - {{ beneficiarioPagina.identidade?.orgaoEmissor }} / {{ beneficiarioPagina.identidade?.uf }}</span>
      <span><strong>Emissão:</strong> {{ beneficiarioPagina.identidade?.dataEmissao | date: 'dd/MM/yyyy' }}</span>

      <span><strong>Título Eleitoral:</strong> {{ beneficiarioPagina.tituloEleitoral?.numero }}</span>
      <span><strong>Zona:</strong> {{ beneficiarioPagina.tituloEleitoral?.zona }}</span>
      <span><strong>Seção:</strong> {{ beneficiarioPagina.tituloEleitoral?.secao }}</span>
      <span><strong>Município:</strong> {{ beneficiarioPagina.tituloEleitoral?.municicio }}</span>

      <span><strong>Reservista:</strong> {{ beneficiarioPagina.carteiraReservista?.numero }} ({{ beneficiarioPagina.carteiraReservista?.serie }} - {{ beneficiarioPagina.carteiraReservista?.categoria }})</span>

      <span><strong>Carteira Profissional:</strong> {{ beneficiarioPagina.carteiraProfissional?.numero }} / Série {{ beneficiarioPagina.carteiraProfissional?.serie }}</span>
      <span><strong>UF:</strong> {{ beneficiarioPagina.carteiraProfissional?.uf }}</span>
      <span><strong>PIS/PASEP:</strong> {{ beneficiarioPagina.carteiraProfissional?.pisPasep }}</span>
    </div>
  </mat-card>

  <!-- Endereço -->
  <mat-card class="militar-info">
    <h2>Endereço</h2>
    <div class="info-row">
      <span><strong>Logradouro:</strong> {{ beneficiarioPagina.endereco?.tipoLogradouro }} {{ beneficiarioPagina.endereco?.logradouro }}</span>
      <span><strong>Número:</strong> {{ beneficiarioPagina.endereco?.numero }}</span>
      <span><strong>Bairro:</strong> {{ beneficiarioPagina.endereco?.bairro }}</span>
      <span><strong>Município:</strong> {{ beneficiarioPagina.endereco?.municipio }}</span>
      <span><strong>UF:</strong> {{ beneficiarioPagina.endereco?.uf }}</span>
      <span><strong>CEP:</strong> {{ beneficiarioPagina.endereco?.cep }}</span>
      <span *ngIf="beneficiarioPagina.endereco?.complemento"><strong>Complemento:</strong> {{ beneficiarioPagina.endereco?.complemento }}</span>
    </div>
  </mat-card>

  <!-- Telefones -->
  <mat-card class="militar-info">
    <h2>Telefones</h2>
    <div class="info-row" *ngFor="let tel of beneficiarioPagina.telefones">
      <span>
        <strong>{{ tel.tipoTelefone }}:</strong>
        {{ tel.ddd }} {{ tel.telefone }}
      </span>
    </div>
  </mat-card>

</div>
